import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Index.css";
import logo from "../../Imagenes/logoMundo_shop.jpeg";

const API = process.env.REACT_APP_API_URL

export default function Index() {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "null");
  const [productos, setProductos] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const navigate = useNavigate();
  const [open,setOpen] = useState(false)

  const renovarToken = async () => {
    try {
      const res = await fetch(`${API}/user/refresh`, {
        method: "POST",
        credentials: "include" // Importante para enviar la cookie de Refresh Token
      });
      
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("token", data.accessToken);
        return true;
      }
    } catch (error) {
      console.error("Error crítico en renovación:", error);
    }
    return false;
  };

  const eliminarProducto = async (id) => {
    if (!window.confirm("¿Seguro que deseas eliminar este producto?")) return;

    const peticion = () => fetch(`${API}/productos/EliminarProducto/${id}`, {
      method: "DELETE",
      headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
    });

    let response = await peticion();
    
    if (response.status === 403 || response.status === 401) {
      const renovado = await renovarToken();
      if (renovado) {
        response = await peticion();
        if (response.ok) {
          alert("Producto eliminado tras renovar sesión");
          cargarProductos();
        }
      } else {
        alert("Tu sesión ha expirado, por favor inicia sesión de nuevo.");
        navigate("/login");
      }
    } else if (response.ok) {
      alert("Producto eliminado");
      cargarProductos();
    } else {
      alert("Error al eliminar el producto");
    }
  };

  const cargarProductos = () => {
    fetch(`${API}/productos/traerProductos`)
      .then(res => res.json())
      .then(data => setProductos(data.content || []))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    cargarProductos();
  }, [token]);

  const ActualizarEstado = async (id, nuevoEstado) => {
    const peticion = () => fetch(`${API}/productos/ActualizarEstadoProducto/${id}/${nuevoEstado}`, {
      method: "PUT",
      headers: { 
        "Content-Type": "application/json", 
        "Authorization": `Bearer ${localStorage.getItem("token")}` 
      }
    });

    let response = await peticion();

    if (response.status === 403 || response.status === 401) {
      const renovado = await renovarToken();
      if (renovado) {
        response = await peticion();
        if (response.ok) {
          alert("Estado actualizado tras renovar sesión");
          cargarProductos();
        }
      } else {
        alert("Tu sesión ha expirado, por favor inicia sesión de nuevo.");
        navigate("/login");
      }
    } else if (response.ok) {
      alert("Estado actualizado");
      cargarProductos();
    } else {
      alert("Error al actualizar el estado");
    }
  };

  return (
    <div className="layout-container">

      {/* NAVBAR */}
      <header className="navbar">
        <div className="container nav-wrapper">
          <div className="nav-brand" style={{ cursor: 'pointer' }}>
            <img src={logo} alt="Logo" className="logo-img" />
            <span className="brand-name">MundoShop</span>
          </div>
          <nav>

<button className="menu-toggle" onClick={() => setOpen(!open)}>
        ☰
      </button>

      
      <div className={`nav-menu ${open ? 'open' : ''}`}>
         <NavLink to="/categorias">Categorías</NavLink>
            {user?.rol === "ROLE_CLIENTE" && <NavLink to="/carrito">Carrito</NavLink>}
            {user?.rol === "ROLE_ADMIN" && <NavLink to="/AdminPedidos">Pedidos</NavLink>}
            {user?.rol === "ROLE_ADMIN" && <NavLink to="/ProductosAgotadosInactivos">Productos inactivos</NavLink>}
            {!token ? (
              <NavLink to="/login" className="btn-login-nav">Login</NavLink>
            ) : (
              <NavLink to="/PerfilUser" className="user-profile-link">
                Perfil
              </NavLink>
            )}
      </div>
    
          </nav>
        </div>
      </header>

      {/* SECCIÓN BUSCADOR */}
      <div className="search-section-wrapper">
        <div className="container">
          <div className="search-box">
            <span className="search-icon">🔍</span>
            <input
              type="text"
              placeholder="Busca tus productos favoritos..."
              className="input-busqueda-pro"
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
            />
            {busqueda && (
              <button className="clear-search" onClick={() => setBusqueda("")}>✕</button>
            )}
          </div>
        </div>
      </div>

      {/* HERO SECTION */}
      <section className="hero">
        <div className="container hero-wrapper">
          <div className="hero-content">
            <span className="hero-badge">🚀 Envios a toda Colombia</span>
            <h1>Mundo Shop: <br /><span className="text-gradient">Tu tienda de confianza</span></h1>
            <p>Descubre productos innovadores que facilitan tu vida. Calidad garantizada y soporte 24/7.</p>
            <div className="hero-cta-group">
              <NavLink to="/categorias" className="btn-main">Comprar Ahora</NavLink>
              <a href="https://wa.me/573005661286" className="btn-wa" target="_blank" rel="noreferrer">WhatsApp</a>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-blob">
              <img src={logo} alt="Mundo Shop Hero" className="hero-img-main" />
            </div>
          </div>
        </div>
      </section>

      {/* BENEFICIOS */}
      <section className="features-bar">
        <div className="container features-grid">
          <div className="feature-card"><span>🚚</span><p>Envío Nacional</p></div>
          <div className="feature-card"><span>💳</span><p>Pago Seguro</p></div>
          <div className="feature-card"><span>⚡</span><p>Entrega Rápida</p></div>
        </div>
      </section>

      {/* PRODUCTOS */}
      <main className="container products-section">
        <div className="section-header">
          <h2 className="section-title">
            {busqueda ? `Resultados para: "${busqueda}"` : "Lo más vendido"}
          </h2>
          {user?.rol === "ROLE_ADMIN" && (
            <NavLink to="/AgregarProducto" className="btn-add-admin">+ Nuevo</NavLink>
          )}
        </div>

        <div className="productos-gridIndex">
          {productos
            .filter(p => p.nombre.toLowerCase().includes(busqueda.toLowerCase()))
            .map(p => (
              <div className="producto-cardIndex" key={p.id}>
                <div className="card-imgIndex">
                  <img
                    src={`${API}${p.imagenesURLs?.[0]}`}
                    alt={p.nombre}
                    onError={(e) => { e.target.src = 'https://via.placeholder.com/300'; }}
                  />
                </div>
                <div className="card-bodyIndex">
                  <h4 className="nombre-ajustado">{p.nombre}</h4>
                  
                  {/* STOCK LIMPIO SIN CÍRCULO */}
                  <p className={p.stock <= 10 ? "stock-bajo" : "stock-normal"}>
                    {p.stock <= 10 ? `Últimas ${p.stock} unidades` : `${p.stock} disponibles`}
                  </p>

                  {p.precioAnterior && (
                    <p className="card-price precio-tachado-rojo">
                      {new Intl.NumberFormat("es-CO", {
                        style: "currency",
                        currency: "COP",
                        minimumFractionDigits: 0
                      }).format(p.precioAnterior)}
                    </p>
                  )}

                  <p className="card-price">
                    {new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 }).format(p.precio)}
                  </p>

                  <NavLink to={`/verProducto/${p.id}`} className="btn-detail">Ver producto</NavLink>

                  {user?.rol === "ROLE_ADMIN" && (
                    <div className="admin-zone">
                      <select
                        className="admin-select"
                        value={p.estado}
                        onChange={(e) => setProductos(prev => prev.map(prod => prod.id === p.id ? { ...prod, estado: e.target.value } : prod))}
                      >
                        <option value="ACTIVO">ACTIVO</option>
                        <option value="AGOTADO">AGOTADO</option>
                        <option value="INACTIVO">INACTIVO</option>
                      </select>
                      <div className="admin-btns-row">
                        <button onClick={() => navigate(`/EditarProducto/${p.id}`)} className="btn-admin">✏️</button>
                        <button onClick={() => eliminarProducto(p.id)} className="btn-admin delete">🗑️</button>
                        <button onClick={() => ActualizarEstado(p.id, p.estado)} className="btn-admin save">OK</button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
        </div>

        {/* MENSAJE NO RESULTADOS */}
        {productos.filter(p => p.nombre.toLowerCase().includes(busqueda.toLowerCase())).length === 0 && (
          <div className="no-results">
            <p>No encontramos productos que coincidan con tu búsqueda 😕</p>
          </div>
        )}
      </main>

      {/* FOOTER */}
      <footer className="footer">
        <div className="container footer-grid">
          <div className="footer-info">
            <h3>Mundo Shop</h3>
            <p>Llevamos lo mejor del mercado a la puerta de tu casa.</p>
          </div>
          <div className="footer-links-group">
            <h4>Navegacion</h4>
            <NavLink to="/categorias">Categorías</NavLink>
            {user?.rol === "ROLE_CLIENTE" && <NavLink to="/carrito">Carrito</NavLink>}
            {user?.rol === "ROLE_ADMIN" && <NavLink to="/AdminPedidos">Pedidos</NavLink>}
            {user?.rol === "ROLE_ADMIN" && <NavLink to="/ProductosAgotadosInactivos">Productos inactivos</NavLink>}
            {!token ? (
              <NavLink to="/login" className="btn-login-nav">Login</NavLink>
            ) : (
              <NavLink to="/PerfilUser" className="user-profile-link">
                {user?.nombre?.split(" ")[0]}
              </NavLink>
            )}
          </div>
          <div className="footer-links-group">
            <h4>Legales</h4>
            <NavLink to="/politicas/Devoluciones">Devoluciones</NavLink>
            <NavLink to="/politicas/ReembolsosCancelacion">Reembolsos</NavLink>
            <NavLink to="/politicas/Envios">Envíos</NavLink>
            <NavLink to="/politicas/Garantias">Garantías</NavLink>
          </div>
          <div className="footer-links-group">
            <h4>Privacidad</h4>
            <NavLink to="/politicas/Privacidad">Privacidad</NavLink>
            <NavLink to="/politicas/TerminosCondiciones">Términos</NavLink>
          </div>
        </div>
        <div className="footer-bottom">© 2026 Mundo Shop - Conectando tus deseos</div>
      </footer>
    </div>
  );
}